var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMannequin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10230_85628)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8747 3.875C14.8747 5.46282 13.5876 6.75 11.9997 6.75C10.4119 6.75 9.12473 5.46282 9.12473 3.875C9.12473 2.28718 10.4119 1 11.9997 1C13.5876 1 14.8747 2.28718 14.8747 3.875ZM16.7915 10.5835C15.6067 12.2996 14.8747 14.6724 14.8747 17.2918H12.958V22.0832L15.833 22.5625V24H8.1662V22.5625L11.0412 22.0832V17.2918H9.12473C9.12473 14.6724 8.39304 12.2996 7.20825 10.5835V8.66648H16.7915V10.5835Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10230_85628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMannequin);
export default __webpack_public_path__ + "static/media/icon-mannequin.6734af0300ca448f27e3f713309df2e9.svg";
export { ForwardRef as ReactComponent };